import React from 'react';
import { Button, Form, FormGroup, Label, Input, Spinner } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import firebase from '../lib/Firebase';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion, faEye } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope, faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import './SignIn.css';


class SignIn extends React.Component {
  state = {
    loading: false,
    showPassword: false,

    openResetPasswordDialog: false,
    resetPasswordMailState: null,

    showOneTimePassowrd: false,
    enableOneTimePasswordLoginButton: false,
  }
  
  _isMounted = false;
  oneTimeToken = null;

  handleOnSubmit = (values) => {
    if (this._isMounted) this.setState({ loading: true });
    
    firebase.auth().signInWithEmailAndPassword(values.email.trim(), values.password)
      .then(res => {
        this.props.history.push("/");
        if (this._isMounted) this.setState({ loading: false });
      })
      .catch(error => {
        if (this._isMounted) this.setState({ loading: false });
        
        if (error.code === 'auth/wrong-password') {
          alert('パスワードが正しくありません。');
          return;
        }

        if (error.message.indexOf("need-motp-auth") >= 0) {
          let m = error.message.toString().match(/^Firebase: HTTP Cloud Function returned an error: ({.*})/);
          if (m) {
            let msg = JSON.parse(m[1]);
            //console.log(msg)
            if (msg && msg.error.message === 'need-motp-auth') { // mail oneTimePassword
              this.setState({ showOneTimePassowrd: true, enableOneTimePasswordLoginButton:false });
              this.oneTimeToken = msg.error.details.token;
              //console.log(this.oneTimeToken)
              return;
            }
          }
        }
        //console.log(error.message);
      });
  }
  
  handleOnShowPassword = (e) =>{
    switch (e.nativeEvent.type) {
      case 'mousedown': this.setState({showPassword:true}); break;
      default: this.setState({showPassword:false}); break;
    }
    e.stopPropagation();
  }
  
  handleOnForgetPassword = bool => {
    if (!bool) {
      this.setState({
        openResetPasswordDialog:bool,
        resetPasswordMailState:null,
      });
    }
    else {
      this.setState({openResetPasswordDialog:bool});
    }
  }
  sendPasswordResetEmail = values => {
    this.setState({resetPasswordMailState:'sending'});
    firebase.auth().sendPasswordResetEmail(values.resetEmail)
      .then(() => {
        this.setState({resetPasswordMailState:'sended'});
      })
      .catch(err => {
        this.setState({resetPasswordMailState:null});
      });
  }
  
  componentDidMount = () => {
    this._isMounted = true;
  }
  
  componentWillUnmount = () => {
    this._isMounted = false;
  }
  
  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (!prevState.showOneTimePassowrd && this.state.showOneTimePassowrd && this.oneTimePasswordInput_1) this.oneTimePasswordInput_1.focus();
  }

  getYear = () => {
    return (new Date()).getFullYear();
  }

  onClickOneTimePasswordLoginButton = e => {
    e.preventDefault();
    this.getCustomToken();
  }
  getCustomToken = () => {
    this.setState({enableOneTimePasswordLoginButton:false});

    let otp = '';
    for (let i = 1; i <=6; i++) {
      otp += this.oneTimePasswordForm['otp_'+i].value;
    }

    let xhr = new XMLHttpRequest();
    xhr.open('post', 'https://createcustomclaim-nv3ehm4qla-an.a.run.app', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer '+this.oneTimeToken);
    xhr.responseType = 'json';
    xhr.onload = () => {
      if (xhr.status === 200) {
        this.setState({
          loading:true,
          showOneTimePassowrd:false
        });
        firebase.auth().signInWithCustomToken(xhr.response.customToken)
          .then(res => {
            this.props.history.push("/");
            if (this._isMounted) this.setState({ loading: false });
          })
          .catch(error => {
          });
      }
      this.setState({enableOneTimePasswordLoginButton:true});
    }
    xhr.send(JSON.stringify({
      otp
    }));
  }
  onKeydownOneTimePassword = e => {
    //e.preventDefault();

    if (e.nativeEvent.keyCode !== 86 && !e.nativeEvent.metaKey) {
      e.preventDefault();
    }
    e.stopPropagation();
    let n = parseInt(e.target.name.substr(e.target.name.length-1), 10);

    if ( (48 <= e.nativeEvent.keyCode &&  e.nativeEvent.keyCode <= 57) || (96 <= e.nativeEvent.keyCode &&  e.nativeEvent.keyCode <= 105)) {
      e.target.value = e.nativeEvent.key;
      if (e.target.value !== '' && n !== 6) {
        this.oneTimePasswordForm['otp_'+(n+1)].focus();
      }
    }
    else if (e.nativeEvent.keyCode === 37) {// <-
      if (n !== 1) {
        this.oneTimePasswordForm['otp_'+(n-1)].focus();
      }
    }
    else if (e.nativeEvent.keyCode === 39) {// ->
      if (n !== 6) {
        this.oneTimePasswordForm['otp_'+(n+1)].focus();
      }
    }
    else if (e.nativeEvent.keyCode === 13) {// enter
      let allInputed = true;
      for (let i = 1; i <=6; i++) {
        allInputed = allInputed && this.oneTimePasswordForm['otp_'+i].value !== '';
      }
      if (allInputed) {
        this.getCustomToken();
        return;
      }
    }
    else if (e.nativeEvent.keyCode === 8 || e.nativeEvent.keyCode === 46) {// bs del
      if (e.target.value === '' && n !== 1) this.oneTimePasswordForm['otp_'+(n-1)].focus();
      e.target.value = '';
    }


    e.target.value = e.target.value.substr(e.target.value.length-1);
    let allInputed = true;
    for (let i = 1; i <=6; i++) {
      allInputed = allInputed && this.oneTimePasswordForm['otp_'+i].value !== '';
    }
    this.setState({enableOneTimePasswordLoginButton:allInputed});
  }
  onInputOneTimePassword = e => {
    let v = e.target.value.trim();
    if (v.length >= 6) {
      v.split('').forEach((c, i) => {
        if (i >= 6) return;
        this.oneTimePasswordForm['otp_'+(i+1)].value = c;
      });
      this.setState({enableOneTimePasswordLoginButton:true});
    }
  }
  onClickOneTimePassword = e => {
    if (e.target.name.match(/^otp_\d$/)) {
      e.target.select();
    }
  }
  
  render() {
    let sendResetPasswordMailMessage = 'アカウントのメールアドレスをご入力ください。パスワード再設定のためのメールを送付いたします。';
    if (this.state.resetPasswordMailState === 'sending') sendResetPasswordMailMessage = 'メールを送信しています。';
    if (this.state.resetPasswordMailState === 'sended') sendResetPasswordMailMessage = 'メールを送信しました。メールの案内に従ってパスワードの再設定を行なってください。';

    return (
      <div className="container SignIn">
        <div className="SignIn-decoration SignIn-decoration-top">
          <div className="SignIn-row">
            <div className="SignIn-square"></div><div className="SignIn-square"></div><div className="SignIn-square"></div><div className="SignIn-square"></div><div className="SignIn-square"></div>
          </div>
        </div>
        <div className="SignIn-decoration SignIn-decoration-bottom">
          <div className="SignIn-row">
            <div className="SignIn-square"></div><div className="SignIn-square"></div><div className="SignIn-square"></div><div className="SignIn-square"></div><div className="SignIn-square"></div>
          </div>
        </div>
        <div className="SignIn-copyright">©︎2019-{this.getYear()} APPX Co,.Ltd.</div>
      
        <div className="SignIn-Center">
          <div className="SignIn-Inputs">
            <h1 className="SignIn-Title Title">アルバムサポート
              <p className="Title-Sub">AlbumSupport</p>
            </h1>
            <Formik
              initialValues={{ email: '', password: '' }}
              onSubmit={(values) => this.handleOnSubmit(values)}
              validationSchema={Yup.object().shape({
                email: Yup.string().email().required(),
                password: Yup.string().required(),
              })}
              >
              {
                ({ handleSubmit, handleChange, handleBlur, values, errors, touched }) => (
                  <Form onSubmit={ handleSubmit }>
                    <FormGroup>
                      <label htmlFor="email">メールアドレス</label>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={touched.email && errors.email ? true : false}
                        autoComplete="username"
                        placeholder="メールアドレス"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="password">パスワード</Label>
                      <div className="SignIn-InputWrap">
                        <Input
                          type={this.state.showPassword ? "text" : "password"}
                          name="password"
                          id="password"
                          value={values.pasword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          invalid={touched.password && errors.passowrd ? true : false}
                          autoComplete="current-password"
                          placeholder="パスワード"
                        />
          <FontAwesomeIcon className="SignIn-ShowPasswordBtn" icon={faEye} onMouseDown={this.handleOnShowPassword} onMouseUp={this.handleOnShowPassword} onMouseOut={this.handleOnShowPassword}/>
                      </div>
                    </FormGroup>
                    <div>
                      <Button className="SignIn-LoginBtn" type="submit" disabled={this.state.loading}>
                        <Spinner size="sm" color="light" style={{ marginRight: 5 }} hidden={!this.state.loading} />
                        ログイン
                      </Button>
                    </div>
                    <div>
                      <Button className="SignIn-ForgetPasswordBtn" onClick={()=>this.handleOnForgetPassword(true)}>
                        <FontAwesomeIcon style={{margin:"0 0.5em"}} icon={faQuestion} />
                        パスワードをお忘れの方
                      </Button>
                    </div>
                  </Form>
                )
              }
            </Formik>
          </div>
        </div>

        {
          this.state.showOneTimePassowrd
          ? (<div className="SignIn-OneTimePasswordDialog">
            <div className="window">
              <div className="title">多要素認証</div>
              <div className="mesage">ご登録いただいているメールアドレス（ログインID）宛に、有効期限5分のワンタイムパスワードを自動送信しました。ワンタイムパスワードを入力し、ログインしてください。</div>
              <form className="oneTimePasswordForm" ref={ref=>{this.oneTimePasswordForm = ref}} onKeyDown={this.onKeydownOneTimePassword} onInput={this.onInputOneTimePassword} onClick={this.onClickOneTimePassword}>
                <input name="otp_1" ref={ref=>{this.oneTimePasswordInput_1 = ref}}/>
                <input name="otp_2"/>
                <input name="otp_3"/>
                <input name="otp_4"/>
                <input name="otp_5"/>
                <input name="otp_6"/>
              </form>
              <button className="loginButton" onClick={this.onClickOneTimePasswordLoginButton} disabled={!this.state.enableOneTimePasswordLoginButton}>ログイン</button>
              <div className="explain">
                <h3>アルバムサポートへの多要素認証導入のお知らせ</h3>
                <p>昨今、卒業アルバム業界における情報漏洩事案が頻発しており、お客様の情報を保護することが喫緊の課題となっております。つきましては、お客様に安心して「アルバムサポート」をご利用いただくため、この度、多要素認証を導入いたしました。</p>
                <p>具体的には、アルバムサポートにログインする際に、ご登録いただいているメールアドレス（ログインID）宛に、有効期限5分のワンタイムパスワードが自動送信されます。そのワンタイムパスワードを入力いただくことで、ログイン可能となります。</p>
                <p>アルバムサポートにご登録されているメールアドレスを変更したい場合や、運用上アカウントを使い分けたい場合など、ご質問やご不明な点がございましたら、お手数ですが担当営業までお問い合わせください。</p>
                <p>お客様にはご不便をおかけいたしますが、何卒ご理解とご協力をお願い申し上げます。</p>
              </div>
            </div>
          </div>)
          : null
        }

        <div className="SiginIn-ResetPasswordDialog" style={this.state.openResetPasswordDialog ? {display:'block'} : {display:'none'}}>
          <div className="window">
            <div className="title">パスワードの再設定</div>
            <div className="message" >{sendResetPasswordMailMessage}</div> 
            
            <Formik
              initialValues={{ resetEmail: '' }}
              onSubmit={(values) => this.sendPasswordResetEmail(values)}
              onChange={(e)=>{console.log(e)}}
              validationSchema={Yup.object().shape({
                resetEmail: Yup.string().email().required()
              })}>
              {
                ({ handleSubmit, handleChange, handleBlur, values, errors, touched }) => (
                  <Form onSubmit={ handleSubmit }>
                    <div className="email"><FontAwesomeIcon icon={faEnvelope}/>
                      <Input
                        type="email"
                        name="resetEmail"
                        id="resetEmail"
                        value={values.resetEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        disabled={this.state.resetPasswordMailState !== null}
                        invalid={touched.email && errors.email ? true : false}
                      />
                    </div>
                    <div className="buttons">
                      <Button className="cancelBtn" onClick={()=>this.handleOnForgetPassword(false)}>キャンセル</Button>
                      <Button className="sendMailBtn" type="submit" disabled={this.state.resetPasswordMailState !== null} hidden={this.state.resetPasswordMailState === 'sended'}><FontAwesomeIcon icon={faPaperPlane}/>送信</Button>
                    </div>
                  </Form>
                )
              }     
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignIn);